module.exports = __webpack_public_path__ + "static/queen-e488752e7ccf2a5774823da2ebe21ef2.png";